/**
 * Opt-in sales-order document extensions (Create Document menu + settings nav).
 * Always-on docs (BOL, packing slip) stay on the OrderAction pipeline.
 *
 * @see docs/OPT_IN_ORDER_DOCUMENTS.md
 * @see registry.ts — slug catalog (menu labels, settings nav)
 * @see gating.ts — client enablement + lifecycle
 * @see useOptInOrderDocumentForm.ts — shared modal prefill/mutation wiring
 * @see opt-in-order-document.schema.ts — tRPC prefill/create inputs
 * @see ~/shared/documents/order-document-settings.ts — enablement + per-slug config storage
 */

export type { OptInOrderDocumentCreateInput, OptInOrderDocumentPrefillInput } from "./opt-in-order-document.schema";
export { OptInOrderDocumentCreateInputSchema, OptInOrderDocumentPrefillInputSchema } from "./opt-in-order-document.schema";
export type { GetOrgSetting, OptInOrderDocumentDefinition, OrderDocumentFormProps, OrderMenuDocumentExtensionContext } from "./types";
export { useOptInOrderDocumentForm } from "./useOptInOrderDocumentForm";
export { useOptInOrderDocumentSettingsNavLinks } from "./useOptInOrderDocumentSettingsNavLinks";
export { useOrderMenuDocumentExtensions } from "./useOrderMenuDocumentExtensions";
